export default "__VITE_ASSET__BQzmzvmd__"